<template>
  <v-card shaped elevation="2" class="pa-4">
    <v-card-title class="titulo_card">{{ title }}</v-card-title>
    <v-card-text>
      <!-- Mensaje informativo para aclarar el concepto -->
      <div class="container_info_azul caption">{{ $t("Las palabras [CLIENTE] y [CENTRO] serán sustituidas por el nombre del cliente y de su centro.") }}</div>

      <ValidationObserver ref="validationObserver">

        <ValidationProvider
            :rules="{'required': !check.is_bienvenida_cliente || !check.is_cita_perdida ||
             !check.is_felicitaciones_cumpleanios || !check.is_clientes_perdidos || !check.is_footer}"
            :name="$t('Contenido').toLowerCase()"
            v-slot="{ errors, classes }"
        >
          <vue-editor
              v-model="html"
              :editor-toolbar="custom_toolbar"
              useCustomImageHandler
              @image-added="handle_image_added"
          />
          <span class="error--text">{{ errors[0] }}</span>
        </ValidationProvider>
      </ValidationObserver>

    </v-card-text>
    <!-- Boton para guardar la plantilla -->
    <v-btn block class="primary" @click="save_plantilla" small>
      <v-icon small>mdi-content-save</v-icon>
      <span>{{ $t("Guardar") }}</span>
    </v-btn>
  </v-card>
</template>

<script>
// Basic Use - Covers most scenarios
import { VueEditor } from "vue2-editor";
import {ValidationObserver, ValidationProvider} from "vee-validate";

export default {
  name: "FormPlantillaEmail",
  props: {
    html_value: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    check_value: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    html: null,
    custom_toolbar: [
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],
      ["bold", "italic", "underline", "strike"],
      [{align: ""}, {align: "center"}, {align: "right"}, {align: "justify"}],
      [{list: "ordered"}, {list: "bullet"}],
      [{color: []}, {background: []}],
      ["link", "image"]
    ],
    check: {}
  }),

  methods:{

    async save_plantilla(){
      const form_valid = await this.$refs.validationObserver.validate()
      if(!form_valid) return
      try {
        let configuracion = {}
        configuracion[this.field] = this.html

        const configuracion_envios = await this.$store.dispatch('configuraciones/save', {
          tipo: 'email',
          configuracion
        })

        this.$emit('on_save', configuracion_envios)

        this.$snotify.success(
          this.$t("Acción realizada con éxito"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      } catch (err) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    async handle_image_added(file, Editor, cursorLocation, resetUploader){
      try {
        const url = await this.$store.dispatch('configuraciones/upload_imagen', file)
        Editor.insertEmbed(cursorLocation, "image", url);
        resetUploader()

        this.$snotify.success(
          this.$t("Acción realizada con éxito"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      } catch (err) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    }

  },

  mounted() {
    this.html = this.html_value
    this.check = this.check_value
  },
  components: {
    VueEditor,
    ValidationProvider,
    ValidationObserver
  }
}
</script>

<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";
</style>
